import { render } from "./UAEHub.vue?vue&type=template&id=0b2189ea"
import script from "./UAEHub.vue?vue&type=script&lang=js"
export * from "./UAEHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__